import { render, staticRenderFns } from "./AutoMarketingList.vue?vue&type=template&id=6fd524a0&scoped=true&"
import script from "./AutoMarketingList.vue?vue&type=script&lang=js&"
export * from "./AutoMarketingList.vue?vue&type=script&lang=js&"
import style0 from "./AutoMarketingList.vue?vue&type=style&index=0&id=6fd524a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd524a0",
  null
  
)

export default component.exports